const attractionDomains = {
  Notification: {
    name: 'notification',
    aliasImport: '@platform/notifications',
    path: '/attraction/notifications',
    auth: true,
  },
  CampaignSidebar: {
    name: 'campaign-sidebar',
    aliasImport: '@platform/campaign-sidebar',
    path: '/attraction',
    auth: true,
  },
  CampaignContacts: {
    name: 'contacts',
    aliasImport: '@platform/contacts',
    path: '/attraction/contacts',
    auth: true,
  },
  CampaignAutomation: {
    name: 'campaign-automation',
    aliasImport: '@platform/campaign-automation',
    path: '/attraction/automation',
    unloadApp: true,
    auth: true,
  },
  CampaignDispatches: {
    name: 'campaign-dispatches',
    aliasImport: '@platform/campaign-dispatches',
    path: '/attraction',
    unloadApp: true,
    auth: true,
  },
  CampaignBuilder: {
    name: 'builder',
    aliasImport: '@platform/builder',
    path: '/attraction/builder',
    unloadApp: true,
    auth: true,
  },
  PlatformBroadcast: {
    name: 'broadcast',
    aliasImport: '@platform/broadcast',
    path: '/attraction/campaign',
    unloadApp: true,
    auth: true,
  },
}

const domains = {
  SelfService: {
    name: 'selfservice',
    aliasImport: '@platform/selfservice',
    path: '/home',
    unloadApp: true,
    auth: true,
  },
  Home: {
    name: 'home',
    aliasImport: '@platform/home',
    path: '/default-welcome',
    unloadApp: true,
    auth: true,
  },
  CustomerPanel: {
    name: 'customer-area',
    aliasImport: '@platform/customer-area',
    path: '/customer-area',
    unloadApp: true,
    auth: true,
  },
  Components: {
    name: 'components',
    aliasImport: '@platform/components',
    path: '',
    auth: true,
  },
  Authentication: {
    name: 'authentication',
    aliasImport: '@platform/authentication',
    isService: true,
  },
  FeatureToggle: {
    name: 'feature-toggle',
    aliasImport: '@platform/feature-toggle',
    isService: true,
  },
  EventBus: {
    name: 'eventbus',
    aliasImport: '@platform/eventbus',
    isService: true,
  },
  ChannelMessenger: {
    name: 'channel-messenger',
    aliasImport: '@platform/channel-messenger',
    path: '/channels/messenger',
    unloadApp: true,
    auth: true,
  },
  ChannelSms: {
    name: 'channel-sms',
    aliasImport: '@platform/channel-sms',
    path: '/channels/sms',
    unloadApp: true,
    auth: true,
  },
  ChannelVoice: {
    name: 'channel-voice',
    aliasImport: '@platform/channel-voice',
    path: '/channels/voice',
    unloadApp: true,
    auth: true,
  },
  ChannelWhatsApp: {
    name: 'channel-whatsapp',
    aliasImport: '@platform/channel-whatsapp',
    path: '/channels/whatsapp',
    unloadApp: true,
    auth: true,
  },
  ChannelWebchat: {
    name: 'channel-webchat',
    aliasImport: '@platform/channel-webchat',
    path: '/channels/webchat',
    unloadApp: true,
    auth: true,
  },
  ChannelRcs: {
    name: 'channel-rcs',
    aliasImport: '@platform/channel-rcs',
    path: '/channels/rcs',
    unloadApp: true,
    auth: true,
  },
  Flow: {
    name: 'flow',
    aliasImport: '@platform/flows',
    path: '/bots',
    unloadApp: true,
    auth: true,
  },
  Organizations: {
    name: 'organizations',
    aliasImport: '@platform/organizations',
    path: '/organizations',
    unloadApp: true,
    auth: true,
  },
  ChannelInstagram: {
    name: 'channel-instagram',
    aliasImport: '@platform/channel-instagram',
    path: '/channels/instagram',
    unloadApp: true,
    auth: true,
  },
  PlatformReport: {
    name: 'platform-report',
    aliasImport: '@platform/platform-report',
    path: '/report',
    unloadApp: true,
    auth: true,
  },
  Labs: {
    name: 'labs',
    aliasImport: '@platform/labs',
    path: '/labs',
    unloadApp: true,
    auth: true,
  },
  PlatformErrorsPage: {
    name: 'platform-errors-page',
    aliasImport: '@platform/platform-errors-page',
    path: '/error',
    unloadApp: true,
    auth: false,
  },
  homeV2: {
    name: 'home-v2',
    aliasImport: '@platform/home-v2',
    path: '/welcome',
    unloadApp: true,
    auth: true,
  },
  navbarV2: {
    name: 'navbar-v2',
    aliasImport: '@platform/navbar-v2',
    path: '',
    auth: true,
  },
  feedbackService: {
    name: 'feedback-service',
    aliasImport: '@platform/feedback-service',
    isService: true,
  },
  channelV2: {
    name: 'channel-v2',
    aliasImport: '@platform/channel-v2',
    path: '/channels/email',
    unloadApp: true,
    auth: true,
  },
  customerDataService: {
    name: 'customer-data-service',
    aliasImport: '@platform/customer-data-service',
    isService: true,
  },
  ...attractionDomains,
}

export default domains
